(function (angular, schoolwork12) {

    'use strict';

    var courseManagementController= angular.module(schoolwork12.app.manageCourseManagement.name);
    courseManagementController.controller(schoolwork12.app.manageCourseManagement.controllers.courseManagementSearch , [
         '$scope',
         schoolwork12.app.auth.services.authentication,
         schoolwork12.app.manageCourseManagement.services.courseManagementService,
         '$uibModal',
         '$rootScope',
         'uiGridConstants',
         function ($scope,
                   authentication, courseManagementService, $uibModal, $rootScope, uiGridConstants) {

            $scope.mainModel = {};
            $scope.searchedFilters = {};
            $rootScope.showSavedErrorMsg = false;
            $rootScope.showSavedSuccessMsg = false;
            $rootScope.errors = '';
            // valid roles for Administration Tools
            if (authentication
                    && authentication.isAuthenticated()) {
                    $scope.mainModel.hasCourseManagementRole = authentication.hasCourseManagementRole();

            };

            //Initialize global variables
            $rootScope.hideCourseManagementSearch = false;
            $scope.isLoadingFilters = true;
            $scope.isSearching = false;
            $scope.filters = {
                status: [
                    { id: 1, label: 'Active'},
                    { id: 0, label: 'Inactive'}
                ],
                courseSubjectList: [],
                courseNameCriteria: [
                    { id: 0, label: 'Starts with'},
                    { id: 1, label: 'Contains'},
                    { id: 2, label: 'Ends with'}
                ],
                courseCodeCriteria: [
                    { id: 0, label: 'Starts with'},
                    { id: 1, label: 'Contains'},
                    { id: 2, label: 'Ends with'}
                ],
                gradeLevelList: [],
                courseLevelList: [],
                courseLengthList: [],
                courseTypeList:[],
                courseContentTypeList: [],
                courseVendorList: [],
                stateList: [],
            };

            const errors = {
                invalidCreateDateFrom: schoolwork12.app.manageCourseManagement.errorMessages.invalidCreateDateFrom,
                invalidCreateDateTo: schoolwork12.app.manageCourseManagement.errorMessages.invalidCreateDateTo
            }

            $scope.datePickers = {
                createDateFrom: false,
                createDateTo: false
            };



            //Initialize manage grad plan grid
            $scope.gridOptions = {
                enableFiltering: true,
                exporterMenuCsv: true,
                exporterMenuPdf: false,
                rowHeight: 40,
                paginationPageSizes : [ 25, 50, 75 ],
                paginationPageSize : 25,
                enableGridMenu: true,
                exporterCsvFilename: 'courses.csv',
                onRegisterApi : (gridApi) => {
                    $scope.gridApi = gridApi;
                },
                gridMenuCustomItems: [
                    {
                        title: 'Reactivate Course',
                        action: () => {
                            const courses = $scope.gridApi.selection.getSelectedRows().map(({courseCode}) => { return {courseCode}});
                            $uibModal.open({
                                templateUrl: 'reactivateCourse.html',
                                windowClass: 'alert-Modal',
                                keyboard: false,
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance','$timeout', '$rootScope',
                                    schoolwork12.app.manageCourseManagement.services.courseManagementService,
                                    function(scope, $uibModalInstance,$timeout, $rootScope, courseManagementService) {
                                        scope.closeReactivateModal = () => {
                                            $uibModalInstance.dismiss('cancel');
                                        }

                                        scope.reactivateCourses = () => {
                                            courseManagementService.reactivateCourses(authentication.getCurrentUser().keycode, courses)
                                                .then(()=>{
                                                    $scope.search();
                                                    $rootScope.showSavedSuccessMsg = true;
                                                    $timeout(() => {
                                                        $rootScope.showSavedSuccessMsg = false;
                                                    }, 5000);
                                                })
                                                .catch((error)=>{
                                                    console.log(error);
                                                })
                                                .finally(()=>{
                                                    scope.closeReactivateModal();
                                                })
                                        }
                                    }
                                ],

                            });

                        },
                        order: 0,
                        shown: () => $scope.gridApi.selection.getSelectedRows().length > 0 && $scope.searchIsInactive()
                    },
                    {
                        title: 'Inactivate Course',
                        action: () => {
                            const courses = $scope.gridApi.selection.getSelectedRows().map(({courseCode}) => { return {courseCode}});
                            $uibModal.open({
                                templateUrl: 'deactivateCourse.html',
                                windowClass: 'alert-Modal',
                                keyboard: false,
                                backdrop: 'static',
                                controller: ['$scope', '$uibModalInstance','$timeout', '$rootScope',
                                    schoolwork12.app.manageCourseManagement.services.courseManagementService,
                                    function(scope, $uibModalInstance,$timeout, $rootScope, courseManagementService) {
                                        scope.closeInactivateModal = () => {
                                            $uibModalInstance.dismiss('cancel');
                                        }

                                        scope.inactivateCourses = () => {
                                            courseManagementService.deactivateCourses(authentication.getCurrentUser().keycode, courses)
                                                .then(()=>{
                                                    $scope.search();
                                                    $rootScope.showSavedSuccessMsg = true;
                                                    $timeout(() => {
                                                        $rootScope.showSavedSuccessMsg = false;
                                                    }, 5000);
                                                })
                                                .catch(({data:{_errors}})=>{
                                                    $rootScope.errors = _errors[0];
                                                    $rootScope.errorsMoreDetails = _errors[1];
                                                    $rootScope.showSavedErrorMsg = true;
                                                    $timeout(() => {
                                                        $rootScope.showSavedErrorMsg = false;
                                                    }, 5000);
                                                })
                                                .finally(()=>{
                                                    scope.closeInactivateModal();
                                                })
                                        }
                                    }
                                ],

                            });

                        },
                        order: 0,
                        shown: () => $scope.gridApi.selection.getSelectedRows().length> 0 && $scope.searchIsActive()
                    }
                ],
           };


           //Build column definitions
           $scope.gridOptions.columnDefs = [
               { field: 'courseCode', displayName: 'Course code', width: 130, sort: { direction: uiGridConstants.ASC }, cellTemplate: "<div class='ui-grid-cell-contents ui-grid-link'> <span ui-sref='courseManagement.editCourse({code:row.entity[col.field]})'>{{row.entity[col.field]}}</span> <div>"},
               { field: 'courseContentType.name', displayName: 'Course Content Type', width: 180},
               { field: 'defaultCredits', displayName: 'Default Credits', width: 170},
               { field: 'courseName', displayName: 'Course Name', width: 130},
               { field: 'courseGrade.name', displayName: 'Course Grade', width: 130},
               { field: 'courseLevel.name', displayName: 'Course Level', width: 130},
               { field: 'courseLength.name', displayName: 'Course Length', width: 150},
               { field: 'courseSubject.name', displayName: 'Course Subject', width: 150},
               { field: 'courseTypeObject.name', displayName: 'Course Type', width: 130},
               { field: 'courseVendorsText', displayName: 'Content Vendor', width: 150},
               { field: 'nextCoursesText', displayName: 'Next Course', width: 130},
               { field: 'specifiedStatesText', displayName: 'Specified States', width: 150},
               { field: 'createDate', displayName: 'Created Date', width: 130, cellTemplate: "<div class='ui-grid-cell-contents'>{{row.entity[col.field]| date: 'MM/dd/yyyy' }}</div>"},
               { field: 'createdByName', displayName: 'Created By', width: 130},
               { field: 'modifyDate', displayName: 'Modified Date', width: 120, cellTemplate: "<div class='ui-grid-cell-contents'>{{row.entity[col.field]| date: 'MM/dd/yyyy' }}</div>"},
               { field: 'modifiedByName', displayName: 'Modified By', width: 120}
           ];


            courseManagementService.getCourseManagementSearchFilters(authentication.getCurrentUser().keycode)
                .then((filters) => {
                    for(let filter in filters){
                        if(filter in $scope.filters){
                            $scope.filters[filter].push(...filters[filter]);
                        }
                    }
                    $scope.isLoadingFilters =  false;
                }
            );

            const getFilters = () => {
                const filters =  {...$scope.selectedFilters};

                if (filters.createDateTo)
                    filters.createDateTo = moment(filters.createDateTo).format('L');
                if (filters.createDateFrom)
                    filters.createDateFrom = moment(filters.createDateFrom).format('L');
                return filters;
            }

            const validateForm = () => {
                $scope.formErrors = [];
                const errorsList = [];

                if ($scope.courseManagementForm.createDateFrom.$error.date){
                    errorsList.push(errors.invalidCreateDateFrom);
                }
                if ($scope.courseManagementForm.createDateTo.$error.date){
                    errorsList.push(errors.invalidCreateDateTo);
                }

                $scope.formErrors =  errorsList;

                return errorsList.length === 0;
            }

            $scope.openCreateDateFrom = () => {
                $scope.datePickers.createDateFrom = true;
            };

            $scope.openCreateDateTo = () => {
                $scope.datePickers.createDateTo = true;
            }

            $scope.searchIsActive = () => {
                return $scope.searchedFilters.status === 1;
            }

            $scope.searchIsInactive = () => {
                return $scope.searchedFilters.status === 0;
            }

            $scope.clearFilters = () => {
                $scope.selectedFilters = {
                    status: 1,
                    courseSubjectList: null,
                    courseNameCriteria: 0,
                    courseName: '',
                    courseCodeCriteria: 0,
                    courseCode: '',
                    createDateFrom: null,
                    createDateTo: null,
                    gradeLevelList: null,
                    courseLevelList: null,
                    courseLengthList: null,
                    courseTypeList: null,
                    courseContentTypeList: null,
                    courseVendorList: null,
                    stateList: null
                }
                $scope.searchedFilters = {};
            }

            $scope.closeMessageSuccess = () => {
                $rootScope.showSavedSuccessMsg = false;
            }

             $scope.closeMessageError = () => {
                 $rootScope.showSavedErrorMsg = false;
             }

             $scope.search = () => {
                 if (validateForm()){
                     $scope.isSearching = true;
                     courseManagementService.searchCourses(authentication.getCurrentUser().keycode, getFilters())
                         .then((data)=>{
                             data.forEach((row)=>{
                                 row.createDate = new Date(row.createDate);
                                 row.modifyDate = new Date(row.modifyDate);
                                 row.specifiedStatesText = row.specifiedStates.map(function(course){return course.code}).join("; ");
                                 row.courseVendorsText = row.courseVendors.map((courseVendor)=>courseVendor.name).join("; ");
                                 row.nextCoursesText = row.nextCourses.map((nextCourse)=>nextCourse.nextCourseCode).join("; ");
                             })
                             $scope.gridOptions.data = data;
                         })
                         .finally(()=>{
                             $scope.isSearching =  false;
                             $scope.searchedFilters = $scope.selectedFilters;
                         });
                 }
             }

            $scope.clearFilters();
     
    }]);
}(angular, schoolwork12));
